import { notifications } from "@mantine/notifications"
import i18next from "i18next"

type Props = {
  message?: string
  title?: string
}

export const showSuccessNotification = ({ message, title }: Props = {}) => {
  notifications.show({
    title: title ?? i18next.t("success.title"),
    message: message ?? i18next.t("success.message"),
    color: "var(--mantine-color-success)",
  })
}
